import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { getAnalytics } from "firebase/analytics";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAI, GoogleAIBackend, VertexAIBackend } from "firebase/ai";
import {
  connectDataConnectEmulator,
  getDataConnect,
} from "firebase/data-connect";
import { connectorConfig, dataConnectSettings } from "@dataconnect/generated";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check before any other Firebase service so subsequent SDK
// calls automatically attach an App Check token. Skipped when no site key is
// configured (e.g. local dev without App Check); on localhost we flip into
// debug-token mode so developers can still exercise enforced backends.
const appCheckSiteKey = import.meta.env
  .VITE_FIREBASE_APPCHECK_RECAPTCHA_SITE_KEY;
if (appCheckSiteKey && window.location.hostname === "localhost") {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}
export const appCheck = appCheckSiteKey
  ? initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    })
  : null;

export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const ai = getAI(app, { backend: new GoogleAIBackend() });
export const vertexAi = getAI(app, { backend: new VertexAIBackend() });
export const firebaseApp = app;
// dataConnectSettings carries the generated clientCache config (connector.yaml).
// It only takes effect on instance creation, and this is the first
// getDataConnect call at bootstrap — omitting it here would silently disable
// the client cache for the whole app.
export const dataConnect = getDataConnect(
  app,
  connectorConfig,
  dataConnectSettings
);
export const storage = getStorage(app);
export const functions = getFunctions(app, "europe-west3");

if (window.location.hostname === "localhost") {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectDataConnectEmulator(dataConnect, "localhost", 9399);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}
